// extracted by mini-css-extract-plugin
export default {"container":"AddDiscount-container_hU7tF","button":"AddDiscount-button_LxVVv"};